import { Vector2i, ModifyString } from "js-vextensions";
import * as THREE from "three";
export function PropNameToTitle(propName) {
    return ModifyString(propName, m => [m.startLower_to_upper, m.lowerUpper_to_lowerSpaceLower]);
}
export function ToVector2i(vector) {
    return new Vector2i(vector.x, vector.y);
}
export function ToVector2(vector) {
    return new THREE.Vector2(vector.x, vector.y);
}
export function ToVector3(vector, z = 0) {
    return new THREE.Vector3(vector.x, vector.y, z);
}
